var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "logo-list grid grid__gallery" }, [
    _c(
      "ul",
      { staticClass: "u-reset logo-list--items grid--row" },
      _vm._l(_vm.content.logos, function(item, itemIdx) {
        return _vm.content.logos.length
          ? _c(
              "li",
              { key: itemIdx, staticClass: "logo-list--item grid--col" },
              [
                _c(
                  "a",
                  {
                    staticClass: "u-reset logo-list--link",
                    attrs: {
                      href: item.href,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "logo-list--image",
                      attrs: { src: item.logo.url, alt: item.logo.alt }
                    })
                  ]
                )
              ]
            )
          : _vm._e()
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30eac316", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30eac316","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/logo-list/index.vue
// module id = 317
// module chunks = 5